import { render, staticRenderFns } from "./DisplayScreen.vue?vue&type=template&id=2ec548d4&scoped=true"
import script from "./DisplayScreen.vue?vue&type=script&lang=js"
export * from "./DisplayScreen.vue?vue&type=script&lang=js"
import style0 from "./DisplayScreen.vue?vue&type=style&index=0&id=2ec548d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec548d4",
  null
  
)

export default component.exports